import { render, staticRenderFns } from "./single-batch.vue?vue&type=template&id=c2e6ef62&scoped=true&"
import script from "./single-batch.vue?vue&type=script&setup=true&lang=js&"
export * from "./single-batch.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./single-batch.vue?vue&type=style&index=0&id=c2e6ef62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e6ef62",
  null
  
)

export default component.exports